"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _createSvgIcon = _interopRequireDefault(require("../createSvgIcon"));

var _OperatePeople = _interopRequireDefault(require("@rsuite/icon-font/lib/people/OperatePeople"));

// Generated by script, don't edit it please.
var OperatePeople = (0, _createSvgIcon["default"])({
  as: _OperatePeople["default"],
  ariaLabel: 'operate people',
  category: 'people',
  displayName: 'OperatePeople'
});
var _default = OperatePeople;
exports["default"] = _default;
module.exports = exports.default;